import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
const EMOJIS = ['🥕', '🥦', '🍎', '🍊', '🍌', '🍇', '🥑', '🍅', '🍓', '🌽'];
interface FloatingEmoji {
  id: number;
  emoji: string;
  x: number;
  y: number;
  duration: number;
  delay: number;
  scale: number;
}
export function FloatingEmojis() {
  const [emojis, setEmojis] = useState<FloatingEmoji[]>([]);
  useEffect(() => {
    // Generate random emojis on client side to avoid hydration mismatch
    const newEmojis = Array.from({
      length: 15
    }).map((_, i) => ({
      id: i,
      emoji: EMOJIS[Math.floor(Math.random() * EMOJIS.length)],
      x: Math.random() * 100,
      y: Math.random() * 100,
      duration: 15 + Math.random() * 20,
      delay: Math.random() * 5,
      scale: 0.5 + Math.random() * 0.5
    }));
    setEmojis(newEmojis);
  }, []);
  return <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden" data-id="element-12">
      {emojis.map(emoji => <motion.div key={emoji.id} className="absolute text-4xl opacity-20" initial={{
      x: `${emoji.x}vw`,
      y: `${emoji.y}vh`,
      scale: emoji.scale,
      rotate: 0
    }} animate={{
      y: [`${emoji.y}vh`, `${(emoji.y + 50) % 100}vh`, `${emoji.y}vh`],
      x: [`${emoji.x}vw`, `${(emoji.x + 10) % 100}vw`, `${emoji.x}vw`],
      rotate: [0, 180, 360]
    }} transition={{
      duration: emoji.duration,
      repeat: Infinity,
      ease: 'linear',
      delay: emoji.delay
    }} data-id="element-13">
          {emoji.emoji}
        </motion.div>)}
    </div>;
}